export interface EventListPermissions {
  canViewEventDetails: boolean;
  canReadCard: boolean;
  canViewCardDetails: boolean;
  canReadHandler: boolean;
  canViewHandlersPage: boolean;
  canReadStream: boolean;
  canViewStreamWatch: boolean;
  canViewStreamDetails: boolean;
  canReadList: boolean;
  canViewListDetails: boolean;
}

export const DEFAULT_EVENT_LIST_PERMISSIONS: EventListPermissions = {
  canViewEventDetails: true,
  canReadCard: true,
  canViewCardDetails: true,
  canReadHandler: true,
  canViewHandlersPage: true,
  canReadStream: true,
  canViewStreamWatch: true,
  canViewStreamDetails: true,
  canReadList: true,
  canViewListDetails: true,
};
